"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSidebarState = void 0;
var react_1 = require("react");
var consts_1 = require("./consts");
var isLocalStorageEnabled = true;
try {
    localStorage.getItem('');
}
catch (_a) {
    isLocalStorageEnabled = false;
}
var useSidebarState = function () {
    var getInitialSidebarState = (0, react_1.useMemo)(function () {
        var storedValue = isLocalStorageEnabled ? localStorage.getItem('isSidebarOpen') : null;
        return storedValue !== null ? JSON.parse(storedValue) : true;
    }, []);
    var getInitalBusinessSubmenuState = (0, react_1.useMemo)(function () {
        var storedValue = isLocalStorageEnabled ? localStorage.getItem('isBusinessSubmenuOpen') : null;
        return storedValue !== null ? JSON.parse(storedValue) : false;
    }, []);
    var getInitialOpenSubmenu = (0, react_1.useMemo)(function () {
        var storedValue = isLocalStorageEnabled ? localStorage.getItem('openSubmenu') : null;
        return storedValue !== null ? JSON.parse(storedValue) : null;
    }, []);
    var getInitialServiceAndInfoSubmenuState = (0, react_1.useMemo)(function () {
        var storedValue = isLocalStorageEnabled ? localStorage.getItem('isServiceAndInfoSubmenuOpen') : null;
        if (storedValue === null) {
            if (isLocalStorageEnabled)
                localStorage.setItem('isServiceAndInfoSubmenuOpen', 'true');
            return true;
        }
        return JSON.parse(storedValue);
    }, []);
    var _a = (0, react_1.useState)(getInitialSidebarState), isSidebarOpen = _a[0], setIsSidebarOpen = _a[1];
    var _b = (0, react_1.useState)(getInitalBusinessSubmenuState), isBusinessSubmenuOpen = _b[0], setIsBusinessSubmenuOpen = _b[1];
    var _c = (0, react_1.useState)(getInitialServiceAndInfoSubmenuState), isServiceAndInfoSubmenuOpen = _c[0], setIsServiceAndInfoSubmenuOpen = _c[1];
    // custom event for outside react trees only
    (0, react_1.useEffect)(function () {
        var handleSidebarStateChange = function (event) {
            if (event.type === consts_1.SIDEBAR_STATE_CHANGE_EVENT_NAME && event.detail) {
                setIsSidebarOpen(event.detail.newState);
            }
        };
        var handleBusinessSubmenuStateChange = function (event) {
            if (event.type === consts_1.SIDEBAR_BUSINESS_SUBMENU_EVENT_NAME && event.detail) {
                setIsBusinessSubmenuOpen(event.detail.isOpen);
            }
        };
        var handleServiceAndInfoSubmenuStateChange = function (event) {
            if (event.type === consts_1.SIDEBAR_BUSINESS_SUBMENU_EVENT_NAME && event.detail) {
                setIsServiceAndInfoSubmenuOpen(event.detail.isOpen);
            }
        };
        window.addEventListener(consts_1.SIDEBAR_STATE_CHANGE_EVENT_NAME, handleSidebarStateChange);
        window.addEventListener(consts_1.SIDEBAR_BUSINESS_SUBMENU_EVENT_NAME, handleBusinessSubmenuStateChange);
        window.addEventListener(consts_1.SIDEBAR_SERVICE_AND_INFO_SUBMENU_EVENT_NAME, handleServiceAndInfoSubmenuStateChange);
        return function () {
            window.addEventListener(consts_1.SIDEBAR_STATE_CHANGE_EVENT_NAME, handleSidebarStateChange);
            window.addEventListener(consts_1.SIDEBAR_BUSINESS_SUBMENU_EVENT_NAME, handleBusinessSubmenuStateChange);
            window.addEventListener(consts_1.SIDEBAR_SERVICE_AND_INFO_SUBMENU_EVENT_NAME, handleServiceAndInfoSubmenuStateChange);
        };
    }, []);
    return {
        isSidebarOpen: isSidebarOpen,
        setIsSidebarOpen: setIsSidebarOpen,
        isBusinessSubmenuOpen: isBusinessSubmenuOpen,
        setIsBusinessSubmenuOpen: setIsBusinessSubmenuOpen,
        getInitialOpenSubmenu: getInitialOpenSubmenu,
        isServiceAndInfoSubmenuOpen: isServiceAndInfoSubmenuOpen,
        setIsServiceAndInfoSubmenuOpen: setIsServiceAndInfoSubmenuOpen,
    };
};
exports.useSidebarState = useSidebarState;
